/**
 * Javascript for Shop page
 */
import Vue from 'vue';

import Catalog from '../vue/catalog/App.vue';
import CatalogSidebar from '../vue/catalog/Sidebar.vue';

export default {
  init() {
    Vue.component('catalog', Catalog);
    Vue.component('catalog-sidebar', CatalogSidebar);

    new Vue({
      el: '#vue-catalog',
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/archiveProductData.js